const validations = {
  name: {
    required: true,
    maxLength: 255
  },
  class: {
    required: true
  },
  student: {
    required: true
  },
  teacher: {
    required: true
  },
  grade: {
    required: true
  },
  term: {
    required: true
  },
  family: {
    required: true
  },
  other: {
    required: true
  }
};
export { validations };
